/**
 * setUser commits the user to state.
 */
export const setUser = (state, user) => {
  state.user = user;
};
